import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-quantity-order-class-location-part',
  templateUrl: './quantity-order-class-location-part.component.html',
  styleUrls: ['./quantity-order-class-location-part.component.css'],
})
export class QuantityOrderClassLocationPartComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  message: string = '';
  constructor(private api: ApiService) {}

  dataSource: any = {
    chart: {
      theme: 'fusion',
      paletteColors: '#FF6347',
      maxBarHeight: '14',
      showValues: '1',
      baseFontSize: '13',
    },
    data: [],
  };
  loading: boolean = true;
  errorApi: boolean = false;
  typeClassificationLocation: string = 'teste';
  inDataResult: boolean = false;
  @Output() errorEmitter = new EventEmitter();

  ngOnInit(): void {
    this.inDataResult = false;
    this.typeClassificationLocation = '';
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    this.getOrderClassLocationPart(item);
  }

  async getOrderClassLocationPart(item: any) {
    if (!this.validateFilter(item)) return;

    this.inDataResult = false;
    this.typeClassificationLocation = '';
    this.typeClassificationLocation =
      '- ' + item.typeClassificationLocationDescription;
    try {
      this.inDataResult = true;
      this.dataSource.data = [];
      const result = await this.api
        .getQuantityOrderClassLocationPart(
          item.typeClassificationLocation,
          item.branch
        )
        .toPromise();
      if (result.items.length != 0) {
        result.items.sort((a: any, b: any) => b.partQuantity - a.partQuantity);
        result.items.map((el: any) => {
          this.dataSource.data.push({
            label: el.classificationDescription,
            value: el.partQuantity,
          });
        });
        this.errorApi = false;
      } else {
        this.inDataResult = false;
        this.message = CONSTANTS.MESSAGES.DATA_NULL_LOCATIONQUANTITYPART;
        this.errorApi = true;
      }
    } catch (error) {
      this.inDataResult = false;
      this.loading = false;
      this.errorApi = true;
      this.formatErrorMensagem(error.error[0].message);
    } finally {
      if (this.dataSource.data == '') {
        this.errorApi = true;
        this.inDataResult = false;
        this.message = CONSTANTS.MESSAGES.DATA_NULL_LOCATIONQUANTITYPART;
        this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_LOCATIONQUANTITYPART);
      }
      this.loading = false;
    }
  }

  validateFilter(item: any): boolean {
    if (item.typeClassificationLocation == '') {
      this.loading = false;
      this.errorApi = true;
      return false;
    }
    if (item.branch == '') {
      this.message = CONSTANTS.MESSAGES.DATA_BRANCH_NULL;
      this.loading = false;
      this.errorApi = true;
      return false;
    }
    return true;
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: Quantity-location-part \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
